export const facebookPageUrl = 'https://facebook.com/fysio.hier';
export const instagramPageUrl = 'https://instagram.com/fysio.hier';
export const threadsPageUrl = 'https://www.threads.net/@fysio.hier';
